import React from 'react';
import { useNavigate } from 'react-router-dom';
import ButtonLeido from '../Buttons/ButtonLeido';
import { menuGroups } from '../Navigation/NavigationLinks';
import './NotificacionItem.css';

const getModuleName = (url) => {
    if (!url) return 'Sistema';

    for (const group of menuGroups) {
        if (group.to === url) {
            return group.title;
        }
        if (group.items) {
            const item = group.items.find(i => i.to === url);
            if (item) {
                return `${group.title} - ${item.label}`;
            }
        }
    }

    const pathName = url.replace('/', '').replace(/_/g, ' ').replace(/-/g, ' ');
    if (pathName) {
        return pathName.charAt(0).toUpperCase() + pathName.slice(1);
    }
    return 'Sistema';
};

const formatFecha = (f) => {
    if (!f) return '';
    return new Date(f).toLocaleString('es-PE', {
        day: '2-digit', month: '2-digit', year: 'numeric',
        hour: '2-digit', minute: '2-digit'
    });
};

const NotificacionItem = ({ item, esLeida = false, onMarcarLeida }) => {
    const navigate = useNavigate();
    const modulo = getModuleName(item.url_accion);

    return (
        <div 
            className={`notif-item ${esLeida ? 'notif-item-leida' : 'notif-item-pendiente'}`}
            onClick={() => { if (item.url_accion) navigate(item.url_accion); }}
            style={{ cursor: item.url_accion ? 'pointer' : 'default' }}
        >
            <div className="notif-item-body">
                <div className="notif-item-header">
                    <span className="notif-item-modulo">{modulo}</span>
                    {item.fecha && (
                        <span className="notif-item-fecha">{formatFecha(item.fecha)}</span>
                    )}
                </div>
                <span className="notif-item-titulo">{item.titulo}</span>
                <span className="notif-item-text">{item.mensaje}</span>
            </div>
            
            <div className="notif-item-actions">
                {!esLeida ? (
                    <ButtonLeido onClick={(e) => { e.stopPropagation(); onMarcarLeida(item); }} />
                ) : (
                    <div className="notif-leida-badge">Leída</div>
                )}
            </div>
        </div>
    );
};

export default NotificacionItem;
